import './style/styles-talents-list.scss'

import { createComponent } from '@bigyouth/base'
import * as features from './features/exports/talents-list'

Object.values(features).forEach(createComponent)
